<template>
  <ValidationProvider
    :vid="vid"
    :name="$attrs.name"
    :rules="rules"
    v-slot="{ valid, errors }"
  >
    <div class="p-field ">
      <label v-if="$attrs.label" v-bind="$attrs">{{ $attrs.label }}</label>
      <!-- <Dropdown
        v-model.trim="innerValue"
        v-bind="$attrs"
        :options="options"
        :optionLabel="optionLabel"
        :placeholder="placeholder"
        :class="{ 'p-invalid': errors[0] && !valid }"
      />
      <small id="inputLiveFeedback" class="p-invalid">
        {{ errors[0] }}
      </small> -->
      <Dropdown
        v-model.trim="innerValue"
        v-bind="$attrs"
        :options="options"
        :optionLabel="optionLabel"
        :placeholder="placeholder"
        :class="{ 'p-invalid': errors[0] && !valid }"
      >
        <template v-if="customValue" #value="slotProps">
          <div class="p-dropdown-car-value" v-if="slotProps.value">
            <span
              v-for="property in customValue"
              :key="`custom-value-${property}`"
            >
              {{ slotProps.value[property] }}
            </span>
          </div>
          <span v-else>
            {{ slotProps.placeholder }}
          </span>
        </template>
        <template v-if="customOption" #option="slotProps">
          <div class="p-dropdown-car-option">
            <span
              v-for="property in customOption"
              :key="`custom-value-${property}`"
            >
              {{ slotProps.option[property] }}
            </span>
          </div>
        </template>
      </Dropdown>

      <small id="inputLiveFeedback" class="p-invalid">
        {{ errors[0] }}
      </small>
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider
  },
  props: {
    vid: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    optionLabel: {
      type: String
    },
    placeholder: {
      type: String
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    customValue: {
      type: Array,
      default: null
    },
    customOption: {
      type: Array,
      default: null
    },
    // must be included in props
    value: {
      type: null
    }
  },
  data: () => ({
    innerValue: ""
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/base/InputSelect.vue